/* eslint-disable xss/no-mixed-html */
/* eslint-disable id-length */

ACC.reportproblem = {
  commentReportInputId: '#ph-addreturnattachcomments',
  formerrormsg: 'ph-formerrormsg',
  disablebtn: 'ph-disable-button',
  reportProblemDesc: '#cboxContent #ph-detailproblemdesc',
  selectclaimreasoncode: 'select[name=reasonCode]',
  reportreasonerrormsg: '.ph-reportreasonmsg',
  reportdescerrormsg: '.ph-reportdescerrormsg',
  reportproblemsubmitbutton: '.ph-reportproblemsubmitbutton',
  checkForReportAttachmentComment: function() {
    var isCommentValid = 0;

    if ($(ACC.reportproblem.commentReportInputId).is(':visible') && $(ACC.reportproblem.commentReportInputId).val() === '') {
      $(ACC.reportproblem.commentReportInputId).parent().addClass(ACC.neworder.formErrorLabel);
      $('.ph-customerattachmeterrormsg').show();
    } else {
      $(ACC.reportproblem.commentReportInputId).parent().removeClass(ACC.neworder.formErrorLabel);
      $('.ph-customerattachmeterrormsg').hide();
      isCommentValid = 1;
    }

    return isCommentValid;
  },
  checkForReportFormErrors: function(selectclaimreasoncode, reportProblemDesc) {
    var isReportFormValid = 0;

    if ($(ACC.neworder.formErrorCls).length === 0 && $(reportProblemDesc).val() !== '' && $(selectclaimreasoncode).val() !== 'default') {
      isReportFormValid = 1;
    }

    return isReportFormValid;
  }
};
$(document).ready(function() {
  $(document).on('click', '.ph-newproblemreport', function() {
    var orderCode = $(this).attr('data-ordernumber'),
        urlLink = window.location.href,
        trigger = 'linkCategory.clickReportProblem',
        compname = 'linkReportProblem',
        desc = 'Report Problem ' + orderCode,
        userEventObj = '';

    ACC.neworder.uploadedAttachement = [];
    $.ajax({
      url: ACC.config.encodedContextPath + '/claims/popup/' + orderCode,
      data: {
        orderCode: orderCode
      },
      type: 'GET',
      datatype: 'html',
      success: function(result) {
      /* eslint-disable no-negated-condition */
        if (result.indexOf(ACC.neworder.sessionTimeoutIdentifier) !== -1) {
          window.location.reload();
        } else {
          setTimeout(function() {
            $.colorbox({
              html: result,
              maxWidth: '600',
              width: '90%',
              height: 'auto',
              overlayClose: true,
              onClosed: function() {
                ACC.neworder.fileListArray = [];
                ACC.neworder.uploadedAttachement = [];
              }
            });
            $.colorbox.resize();
          }, 200);
          userEventObj = ACC.googleanalytics.createUserEventForGa(urlLink, desc, trigger, compname);
          ACC.googleanalytics.gaEventsForLinks(userEventObj);
        }
        /* eslint-enable no-negated-condition */
      },
      error: function() {
        window.location.reload();
      }
    });
  });

  $(document).on('click', '.ph-orderreportcancel', function() {
    ACC.neworder.fileListArray = [];
    ACC.neworder.uploadedAttachement = [];
    $.colorbox.close();
  });
  $(document).on('change', '.ph-reportProblemValidation', function() {
    var isCommentValid = 0,
        problemDescVal = $(ACC.reportproblem.reportProblemDesc).val();

    if (problemDescVal === '') {
      $(ACC.reportproblem.reportdescerrormsg).show();
      $(ACC.reportproblem.reportProblemDesc).parent().addClass(ACC.reportproblem.formerrormsg);
      $.colorbox.resize();
    } else {
      $(ACC.reportproblem.reportdescerrormsg).hide();
      $(ACC.reportproblem.reportProblemDesc).parent().removeClass(ACC.reportproblem.formerrormsg);
      $.colorbox.resize();
    }

    if ($(ACC.reportproblem.selectclaimreasoncode).val() === 'default') {
      $(ACC.reportproblem.reportreasonerrormsg).show();
      $(ACC.reportproblem.selectclaimreasoncode).parent().addClass(ACC.reportproblem.formerrormsg);
      $.colorbox.resize();
    } else {
      $(ACC.reportproblem.reportreasonerrormsg).hide();
      $(ACC.reportproblem.selectclaimreasoncode).parent().removeClass(ACC.reportproblem.formerrormsg);
      $.colorbox.resize();
    }

    isCommentValid = ACC.reportproblem.checkForReportAttachmentComment();

    if (isCommentValid > 0 && $(ACC.neworder.formErrorCls).length === 0) {
      $(ACC.reportproblem.reportproblemsubmitbutton).removeClass(ACC.reportproblem.disablebtn);
    } else {
      $(ACC.reportproblem.reportproblemsubmitbutton).addClass(ACC.reportproblem.disablebtn);
    }
  });
  $(document).on('click', '#ph-reportsubmit', function() {
    var orderNumber = $(this).attr('data-order'),
        userEventObj = {
          componentName: 'reportSubmitform',
          description: 'Claim Order Issue -' + orderNumber,
          status: 'Success',
          url: window.location.href,
          eventbtnname: 'ph-reportsubmit',
          formid: 'ph-reportproblemordersubmit',
          orderCode: orderNumber,
          reasonCode: $(ACC.reportproblem.selectclaimreasoncode).val(),
          claimDescription: $(ACC.reportproblem.reportProblemDesc).val()
        };

    ACC.googleanalytics.gaEventsForReportOrder(userEventObj);
  });
  $(document).on('click', ACC.reportproblem.reportproblemsubmitbutton, function(event) {
    var ordernum = $(this).attr('data-order'),
        form = $('#ph-reportproblemordersubmit')[0],
        data = new FormData(form),
        len = ACC.neworder.uploadedAttachement.length,
        indx = 0,
        $loaderForReturnBtn = $('.ph-reportproblemsubmitbutton .ph-interstitial-loader');

    event.preventDefault();

    for (indx; indx < len; indx = indx + 1) {
      data.append('attachments', ACC.neworder.uploadedAttachement[indx].file);
    }


    if (ACC.reportproblem.reportProblemDesc === '' && ACC.reportproblem.selectclaimreasoncode === 'default') {
      $(ACC.reportproblem.reportdescerrormsg).show();
      $(ACC.reportproblem.reportreasonerrormsg).show();
      $.colorbox.resize();
    } else if (ACC.reportproblem.reportProblemDesc === '') {
      $(ACC.reportproblem.reportdescerrormsg).show();
      $.colorbox.resize();
    } else if (ACC.reportproblem.selectclaimreasoncode === 'default') {
      $(ACC.reportproblem.reportreasonerrormsg).show();
      $.colorbox.resize();
    } else {
      $loaderForReturnBtn.removeClass('hidden');
      $.ajax({
        url: ACC.config.encodedContextPath + '/claims/confirmation',
        data: data,
        type: 'POST',
        contentType: false,
        cache: false,
        processData: false,
        datatype: 'json',
        success: function(result) {
          if (result.success && result.success.length > 0) {
            $.colorbox.close();
            $('.ph-returnmsg').text(result.success);
            $('#ph-returnconfirmationmsg').removeClass(ACC.neworder.hiddenClass);
            $(window).scrollTop(0);
            $('.ph-ordernum_' + ordernum).addClass(ACC.reportproblem.disablebtn);
            $('#ph-detailbar' + ordernum).removeClass('ph-icon-arrow-up').addClass('ph-icon-arrow-down');
            $('#orderPanel' + ordernum).hide();
            $('#ph-detailbar' + ordernum).parent().removeClass('ph-panel-active');
            ACC.neworder.fileListObject = [];
          } else if (result.attachments && result.attachments.length > 0) {
            $(ACC.neworder.attachmentErrorMsg).html('');
            $.each(result.attachments, function(item) {
              var attachment = '<div class="ph-file-error' + item + ' ">' + result.attachments[item] + '</div>';

              $(ACC.neworder.attachmentErrorMsg).append(attachment).show();

              ACC.neworder.validateAttachment();
            });
          }

          $loaderForReturnBtn.addClass('hidden');
        }
      });
    }
  });
});
$(document).ready(function() {
  var reportProblemDesc = '#cboxContent #ph-detailproblemdesc',
      selectclaimreasoncode = 'select[name=reasonCode]';

  $(document).on('keyup', reportProblemDesc, function() {
    var isCommentValid = 0;

    if ($(ACC.reportproblem.reportProblemDesc).val() === '') {
      $(ACC.reportproblem.reportdescerrormsg).show();
      $(ACC.reportproblem.reportProblemDesc).parent().addClass(ACC.reportproblem.formerrormsg);
      $.colorbox.resize();
    } else {
      $(ACC.reportproblem.reportdescerrormsg).hide();
      $(ACC.reportproblem.reportProblemDesc).parent().removeClass(ACC.reportproblem.formerrormsg);
      $.colorbox.resize();
    }

    isCommentValid = ACC.reportproblem.checkForReportAttachmentComment();

    if (isCommentValid > 0 && $(ACC.neworder.formErrorCls).length === 0) {
      $(ACC.reportproblem.reportproblemsubmitbutton).removeClass(ACC.reportproblem.disablebtn);
    } else {
      $(ACC.reportproblem.reportproblemsubmitbutton).addClass(ACC.reportproblem.disablebtn);
    }
  });

  $(document).on('keyup', '#ph-addreturnattachcomments', function() {
    var isReportFormValid = 0,
        isCommentValid = 0;

    isCommentValid = ACC.reportproblem.checkForReportAttachmentComment();
    isReportFormValid = ACC.reportproblem.checkForReportFormErrors(selectclaimreasoncode, reportProblemDesc);

    if (isCommentValid > 0 && isReportFormValid > 0) {
      $(ACC.reportproblem.reportproblemsubmitbutton).removeClass(ACC.reportproblem.disablebtn);
    } else {
      $(ACC.reportproblem.reportproblemsubmitbutton).addClass(ACC.reportproblem.disablebtn);
    }
  });
  $(document).on('change', '.ph-reportproblem-file', function(event) {
    var input = event.target,
        removeText = $('.ph-remove-text').val(),
        isReportFormValid = 0,
        templateHtml = '',
        claimFileSize = '',
        arrayIndex = ACC.neworder.uploadedAttachement.length;

    if (input.files.length > 0) {
      $.each(input.files, function(index, uploadedFiles) {
        var fileObject = {
          name: ''
        };

        claimFileSize = ACC.neworder.validateFileSize(uploadedFiles);

        if (ACC.neworder.uploadedAttachement.length < 20 && claimFileSize === 'true') {
          ACC.neworder.uploadedAttachement.push({
            id: 'fileId' + arrayIndex,
            file: uploadedFiles
          });
          arrayIndex = arrayIndex + 1;
          fileObject.name = uploadedFiles.name;
          ACC.neworder.fileListObject.push(uploadedFiles);
          ACC.neworder.fileListArray.push(fileObject);
        }
      });

      $.each(ACC.neworder.fileListArray, function(index, uploadedFiles) {
        templateHtml = templateHtml + (
          '<div class="ph-col-12 ph-d-flex ph-col-12 ph-align-items-center ph-file-rows ph-file-row' + index + ' ">' +
          '<div class="ph-col-8 ph-filesec ph-float-left">' +
          '<span class="ph-fileicon ph-float-left"></span>' +
          '<span class="ph-filename">' + uploadedFiles.name + '</span></div>' +
          '<div class="ph-col-4 ph-p-0 ph-float-left ph-remove-file">' +
          '<span class="ph-remove-attchlink" data-index=' + index + '>' + removeText + '</span>' +
          '</div></div>'
        );
      });

      $('#' + ACC.neworder.uploadFileNameId).html(templateHtml);

      if ($('.ph-file-rows').length > 0) {
        $('.ph-return-commentsec').show();
        $('#' + ACC.neworder.uploadFileNameId).show();
      }

      ACC.neworder.showFileMaxSizeError();
      $(ACC.reportproblem.commentReportInputId).focus();

      isReportFormValid = ACC.reportproblem.checkForReportFormErrors(selectclaimreasoncode, reportProblemDesc);

      if (isReportFormValid > 0) {
        $(ACC.reportproblem.reportproblemsubmitbutton).removeClass(ACC.neworder.disabledBtnCls);
      } else {
        $(ACC.reportproblem.reportproblemsubmitbutton).addClass(ACC.neworder.disabledBtnCls);
      }

      $.colorbox.resize();
    }
  });
  $(document).on('click', '.ph-remove-attchlink', function() {
    var index = $(this).attr('data-index'),
        isCommentValid = 0,
        isReportFormValid = 0,
        inx = 0,
        item = $('.ph-remove-attchlink').attr('data-index');

    $(ACC.neworder.attachmentFileRow + index).remove();
    $('.ph-file-error' + item).hide();
    ACC.neworder.fileListArray.splice(index, 1);

    if ($('.ph-file-rows').length === 0) {
      $('.ph-return-commentsec').hide();
      $('#' + ACC.neworder.uploadFileNameId).hide();
      $(ACC.neworder.attachmentErrorMsg).hide();
      ACC.neworder.fileListArray = [];
      ACC.neworder.uploadedAttachement = [];
    } else {
      for (inx; inx < ACC.neworder.uploadedAttachement.length; inx = inx + 1) {
        if (ACC.neworder.uploadedAttachement[inx].id === 'fileId' + index) {
          ACC.neworder.uploadedAttachement.splice(inx, 1);
        }
      }
    }

    isCommentValid = ACC.reportproblem.checkForReportAttachmentComment();
    isReportFormValid = ACC.reportproblem.checkForReportFormErrors(selectclaimreasoncode, reportProblemDesc);

    if (isCommentValid > 0 && isReportFormValid > 0) {
      $(ACC.reportproblem.reportproblemsubmitbutton).removeClass(ACC.reportproblem.disablebtn);
    } else {
      $(ACC.reportproblem.reportproblemsubmitbutton).addClass(ACC.reportproblem.disablebtn);
    }

    $('#file-upload').val('');
    $.colorbox.resize();
  });
});
/* eslint-enable xss/no-mixed-html */
/* eslint-enable id-length */
